<template xmlns="http://www.w3.org/1999/html">

	<div class="learning_cont">
		<section class="learning_test">
			<div class="test_ing">
				<div class="q_wrap">
					<strong>{{ qstFile.fileDesc }} ({{ fileList.length }})</strong>
					<!--<p>상세텍스트 영역입니다. 문제에 해당하는 정확한 답변을 모두 고르세요.</p>-->
				</div>
				<div class="a_wrap">
					<ul>
						<li v-for="(file, i) in fileList">
							<input class="inp_radio" type="checkbox" :id="'file_idx-' + file.fidx" :true-value="true" :false-value="false" :checked="ansFileList[i].isDownload" @click="doDownload( file.fidx )" >
							<label class="lab_radio" :for="'file_idx-' + file.fidx">
								<div class="lab_left">{{ i+1 }}. {{ file.filename }} {{file.isDownload}}</div>
							</label>
						</li>
					</ul>
				</div>
				<warning-message></warning-message>
				<div class="test_button">

					<template v-if="$options.filters.isEmpty( $route.query.isReplay )">
						<button type="button" class="btn btn-lg btn-dark" @click="doComplete($event, true)">
							<template v-if="$parent.isNext()">다음</template>
							<template v-else>파일 이수</template>
						</button>
					</template>
					<template v-else>
						<button type="button" class="btn btn-lg btn-dark" @click="stopProceed">종료</button>
					</template>

				</div>
			</div>
		</section>
		
	</div>

</template>

<script>
import HWAPP from "@/commons/mixins/hwapp.mixin";
import WarningMessage from "@/cs1/components/educations/answer/warningMessage";

export default {
	name: "ansFile",
	components: {WarningMessage},
	props: [
		"eduMain",
		"eduContent",
		"eduAnswer",
	],
	mixins: [HWAPP],
	data: function () {

		return {

			// 문제내용
			qstFile: this.eduContent.qstFileVO,

			// 문제 파일목록
			fileList: this.eduContent.qstFileVO.fileList,

			// 답변 파일목록
			ansFileList: this.eduAnswer.ansFileList,

			// 파일목록 다운로드 여부
			isComplete: false,

			userId: this.getLoginId(),

			isIOS: false,

		}
	},
	mounted: function () {

		if (((navigator.userAgent).indexOf("iPad")) !== -1 || ((navigator.userAgent).indexOf("iPhone")) !== -1 || ((navigator.userAgent).indexOf("iPod")) !== -1 || ((navigator.userAgent).indexOf("Mac")) !== -1) {
			this.isIOS = true;
		}

		//console.log("ans-files");
		//console.log(this.eduMain)
		//console.log(this.eduContent)
		//console.log(this.eduAnswer)

		// alert( this.$parent.isNext() );

		this.initAnsFiles();
		this.isDownload();
	},
	methods: {



		initAnsFiles: function () {



		},


		doDownload: function (_fidx) {

			if (this.appDevice() === "IOS") {
				webkit.messageHandlers.iOSFileDownload.postMessage(this.APIs.EDU_FILE_DOWN + _fidx)
				return;
			}

			var self = this
			self.$eventBus.$emit("startProgress")

			this.axiosCaller.patch(this, this.APIs.EDU_ANSWER + "/file", {
				'fidx': _fidx,
				'eaIdx': this.eduAnswer.eaIdx,
				'userId': this.userId,
			}, function (res) {

				const result = res.data;
				self.ansFileList.forEach(value => {
					if ( value.fidx === _fidx ) {
						value.isDownload = true;
					}
				});
				self.isDownload();

				location.href = self.APIs.EDU_FILE + "/download/" + _fidx

				self.$eventBus.$emit("doneProgress")
			})

			// location.href = $apis.file + "/edu/download?file_idx=" + _fidx

		},


		// c-for 에서 사용할 다운로드 여부
		// _fidx 없을 경우 전체 파일 다운로드 여부
		isDownload: function () {

			var result = true;
			if ( this.ansFileList != null ) {

				this.ansFileList.forEach(value => {

					if ( !value.isDownload ) {
						result = false;
					}
				})
			}
			this.isComplete = result;
		},


		// 교육 이수 완료 처리 및 다음 컨텐츠로 이동
		doComplete: function () {

			/*if ( !this.isComplete ) {
				this.swalUtils.gritter("다운로드 누락", "모든 파일을 다운로드 해야 이수가능합니다.", "info")
				return
			}*/

			var self = this
			this.axiosCaller.patch(this, this.APIs.EDU_ANSWER + "/", {
				eaIdx: self.eduAnswer.eaIdx
			}, function (res) {

				const result = res.data;
				if (result.status === "ok") {
					self.$emit("goNext");
				} else {
					console.log(result.msg);
				}
			})

			/*var self = this
			$http.patch($apis.eduAnswer + "/", {
				eaIdx: this.eduAnswer.eaIdx
			}, function (result) {
				self.$eventBus.$emit("doneProgress")
				self.$emit("goNext")
			})*/





		},


		stopProceed() {
			this.appClose({
				reload: true,
			})
		},


	},
	watch: {

		'eduAnswer': function (newVal) {
			//console.log(newVal)
		}


	}


}
</script>

<style scoped>

</style>